var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"800"}},[_vm._v(" ggggh "),_c('iframe',{style:(_vm.iframe.style),attrs:{"src":_vm.iframe.src,"height":_vm.iframe.height,"width":_vm.iframe.width,"type":"application/pdf","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }